import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=0a5218a6&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=0a5218a6&prod&scoped=true&lang=css"
import style1 from "./SignaturePad.vue?vue&type=style&index=1&id=0a5218a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5218a6",
  null
  
)

export default component.exports